import { Box, Divider } from "@mui/material";
import { colors } from "styles/colors";
import useGlobalStyles from "styles/globalStyles";
import ProfileSectionHeader from "components/common/ProfileSectionHeader/ProfileSectionHeader";
import CalendarIcon from "icons/CalendarIcon";
import RegistryPendingInvitations from "../CreateRegistryForm/RegistryPendingInvitations";

export default function RegistryInvitations() {
  const globalStyles = useGlobalStyles();

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden"
      }}
    >
      <Box px={2}>
        <ProfileSectionHeader
          title={'Pending Invitations'}
          icon={<CalendarIcon color={colors.primary} size={15}/>}
          buttons={[

          ]}
        />
      </Box>

      <Divider />

      <RegistryPendingInvitations />

    </Box>

  );
}
